<template>
  <div>
    <el-tabs value="tab_user" type="border-card" v-model="activeName">
      <el-tab-pane label="权限管理" name="tab_user">

        <el-form ref="form" :model="formQuery" inline size="mini">

          <el-form-item label="用户ID：">
            <el-input v-model="formQuery.userId"></el-input>
          </el-form-item>

          <el-form-item label="角色ID：">
            <el-select v-model="formQuery.role" placeholder="please select your zone">
              <el-option
                  v-for="item in OptsRole"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="企业ID：">
              <el-input v-model="formQuery.qiyeId"></el-input>
          </el-form-item>

          <el-form-item>
            <el-button type="primary" @click="handleAddQiYeManager">添加企业后台管理人员</el-button>
            <el-button type="primary" @click.native.prevent="handleQuery">查询</el-button>
          </el-form-item>
        </el-form>

        <el-table :data="List" size="mini">
          <el-table-column type="expand">
            <template v-slot:="props">
              <vue-json-editor v-model="props.row" :showBtns="true"></vue-json-editor>
            </template>
          </el-table-column>
          <el-table-column label="用户帐号" prop="userId" width="150"/>
          <el-table-column label="用户名" prop="name" width="150"/>
          <el-table-column label="账号角色" prop="role" width="150">
            <template v-slot:="scope">
              <el-tag
                  :type="getRoleTagInfo(scope.row.role).tag"
                  disable-transitions
              >
                {{ getRoleTagInfo(scope.row.role).label }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column label="手机号" prop="phone" width="200"/>
<!--          <el-table-column label="邮箱" prop="email" width="200"/>-->
          <el-table-column label="企业ID" prop="qiyeId" width="200"/>
          <el-table-column label="企业名字" prop="qiyeName" width="200"/>
          <el-table-column label="简介" prop="info"/>
          <el-table-column label="操作" width="400">
            <template v-slot:="scope">
              <div v-if="scope.row.role===Role.YeWuYuan">
                <el-button v-if="(scope.row.saleChannel & 2) === 2"
                           style="margin-left: 10px;"
                           size="mini"
                           @click="handleShowQRCode(scope.$index, scope.row)">展示二维码
                </el-button>
              </div>
              <div v-else>
                <el-button style="margin-left: 10px;"
                           size="mini"
                           @click="handleEditVisble(scope.$index, scope.row)">编辑
                </el-button>
                <el-button style="margin-left: 10px;"
                           size="mini"
                           type="danger"
                           @click="handleDelete(scope.$index, scope.row)">删除
                </el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>

        <el-pagination
            @current-change="handleCurrentChange"
            :current-page.sync="currentPage"
            small
            layout="prev, pager, next"
            :page-size="pageSize"
            :total="totalSize">
        </el-pagination>

      </el-tab-pane>
    </el-tabs>

    <el-dialog title="管理人员信息" :visible.sync="formVisible" :close-on-click-modal="false">
      <el-form ref="form" :model="form" size="mini">

        <el-form-item label="电话：">
          <el-input v-model="form.phone"
                    placeholder=""
                    size="mini"
                    :precision="0"
                    :min="0"
          ></el-input>
        </el-form-item>

        <el-form-item label="邮箱：">
          <el-input v-model="form.email"
                    placeholder=""
                    size="mini"
                    :precision="0"
                    :min="0"
          ></el-input>
        </el-form-item>

        <el-form-item label="extra：">
          <vue-json-editor v-model="form.extra" :showBtns="true"></vue-json-editor>
        </el-form-item>

        <div v-if="form.role!==Role.Server">
          <el-form-item label="密码：">
            <el-input v-model="form.password"
                      placeholder=""
                      size="mini"
                      :precision="0"
                      :min="0"
            ></el-input>
          </el-form-item>
          <el-form-item label="check密码：">
            <el-input v-model="form.checkpassword"
                      placeholder=""
                      size="mini"
                      :precision="0"
                      :min="0"
            ></el-input>
          </el-form-item>
        </div>



        <div v-if="form._id===''">

          <el-form-item label="角色类型：" prop="role">
            <template>
              <el-radio v-model="form.role" :label="1">企业管理员</el-radio>
              <el-radio v-model="form.role" :label="2">后台管理员</el-radio>
              <el-radio v-model="form.role" :label="4">客服</el-radio>
            </template>
          </el-form-item>

          <el-form-item v-if="form.role===Role.QiYe" label="选择所属企业：">
            <el-select
                style="width: 500px;"
                v-model="form.qiyeId"
                filterable
                remote
                reserve-keyword
                placeholder="请输入关键词"
                :remote-method="remoteQiye"
                :loading="logining">
              <el-option
                  v-for="item in options"
                  :key="item._id"
                  :label="item.name"
                  :value="item._id">
              </el-option>
            </el-select>
          </el-form-item>
        </div>

        <el-form-item label="名字：">
          <el-input v-model="form.name"
                    placeholder=""
                    size="mini"
                    :precision="0"
                    :min="0"
          ></el-input>
        </el-form-item>

        <el-form-item label="简介：">
          <el-input v-model="form.info"
                    type="textarea"
                    autosize
          ></el-input>
        </el-form-item>

        <el-form-item v-if="form.role===Role.KeFu" label="每天最大退保数：">
          <el-input v-model="form.maxDaytbNum"
                    placeholder=""
                    size="mini"
                    :precision="0"
                    :min="0"
          ></el-input>
        </el-form-item>

        <el-form-item>
          <el-upload
              class="upload-demo"
              action="https://jsonplaceholder.typicode.com/posts/"
              :on-remove="handleRemove"
              :before-upload="beforeUpload"
              :on-success="handleSuccess"
              :file-list="this.form.pic"
              list-type="picture">
            <el-button size="small" type="primary">点击上传</el-button>
            <div slot="tip" class="el-upload__tip">只能上传jpg/png文件</div>
          </el-upload>
        </el-form-item>


      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="formVisible = false" @click.native.prevent="handleCancel">关闭</el-button>
        <template v-if="this.form._id==''">
          <el-button type="primary" @click.native.prevent="handleAdd">添加</el-button>
        </template>
        <template v-else>
          <el-button type="primary" @click.native.prevent="handleEdit">编辑</el-button>
        </template>
      </div>
    </el-dialog>

    <QRCode ref="qrCode"></QRCode>

  </div>
</template>

<script>
import VueJsonEditor from '@/components/VueJsonEditor';
import QRCode from '@/components/QRCode.vue';
import {OptsRole, getRoleTagInfo} from '@/utils';
import {Role}  from '@/utils/constants'

const resetForm = () => {
  return {
    _id: "",
    name: "",
    password: "",
    checkpassword: "",
    phone: "",
    email: "",
    pic: [],
    //角色
    role: 1,
    //企业
    qiyeId: "",
    qiyeName: "",
    //简介
    info: "",
    maxDaytbNum : 0,
    extra : {}
  }
}

export default {
  components: {
    VueJsonEditor,
    QRCode,
  },
  data() {
    return {
      activeName: 'tab_user',
      Role,
      OptsRole,
      getRoleTagInfo,

      formVisible: false,
      currentPage: 1,
      pageSize: 20,
      totalSize: 0,
      form: resetForm(),
      List: [],
      options: [],
      logining: false,
      formQuery: {
        userId: '',
        role: -1,
        qiyeId: ''
      },
    };
  },
  created() {
    this.current_app = this.$store.state.app
  },

  computed: {
    cur_app() {
      return this.$store.state.app;
    }
  },
  watch: {
    $route(to) {
      if (this.current_app === this.$store.state.app) {
        return
      }
    }
  },
  methods: {
    // 打开对话框并生成二维码
    handleShowQRCode: async function (index, row) {

      this.$axios.post('/qiye/userh5url/list', {
        userId: row.userId,
        qiyeId: row.qiyeId
      }).then(res => {
          this.logining = false;
          // console.log(JSON.stringify(res))
          this.$refs.qrCode.showQRCodeList(row.name, row.phone, res);
        }).catch(res => {
          this.logining = false;
        })
    },

    remoteQiye: function (query) {
      if (query !== '') {
        this.logining = true;

        let params = {
          query
        }

        this.$axios.post('/qiye/quick/list', params).then(res => {
          this.options = res.qiye;
          // console.log('options:',JSON.stringify(this.options));
          this.logining = false;
        }).catch(res => {
          this.logining = false;
        })
      } else {
        this.options = [];
      }
    },

    handleAddQiYeManager: function (index, row) {
      this.form = resetForm();
      this.formVisible = true;
    },

    handleEditVisble: function (index, row) {

      console.log(`handleEditVisble: ${JSON.stringify(row)}`);
      this.form = {
        name: row.name,
        phone: row.phone,
        email: row.email,
        info: row.info,
        pic: row.pic,
        _id: row._id,
        role: row.role,
        qiyeId: row.qiyeId,
        qiyeName: row.qiyeName,
        maxDaytbNum: row.maxDaytbNum,
        extra : row.extra || {},
      }
      // console.log(`handleEditVisble: ${JSON.stringify(this.form)}`);
      this.formVisible = true
    },

    handleEdit: function (index, row) {
      if (this.form.password !== this.form.checkpassword) {
        this.$message.error('密码输入不相同');
        return;
      }
      let params = {
        _id: this.form._id,
        phone: this.form.phone,
        name: this.form.name,
        email: this.form.email,
        info: this.form.info,
        pic: this.form.pic,
        password: this.form.password,
        maxDaytbNum: this.form.maxDaytbNum,
        extra: this.form.extra,
      };
      // console.log(`修改：${JSON.stringify(params)}`);
      this.$axios.post('/auth/manager/edit', params).then(res => {
        this.$message.info('修改用户成功');
      }).catch(res => {
        this.logining = false;
      })
      this.formVisible = false;
      this.resetform();
    },

    handleDelete: function (index, row) {
      // console.log(`即将删除：${JSON.stringify(row)}`);
      this.$confirm("确认删除用户？", "警告", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "red"
      }).then(() => {

        let params = {
          _id: row._id,
        }
        this.logining = true;
        this.$axios.post('/auth/manager/delete', params).then(res => {
          this.$message.info('删除用户成功');
        }).catch(res => {
          this.logining = false;
        })

      }).catch(() => {
      })

    },

    handleAdd: function () {
      if (this.form.password !== this.form.checkpassword) {
        this.$message.error('密码输入不相同');
        return;
      }

      let params = {
        name: this.form.name,
        phone: this.form.phone,
        password: this.form.password,
        email: this.form.email,
        info: this.form.info,
        pic: this.form.pic,
        role: this.form.role,
        qiyeId: this.form.qiyeId,
        qiyeName: this.form.qiyeName,
        type: 0,
        maxDaytbNum: this.form.maxDaytbNum,
        extra: this.form.extra,
      };

      // console.log(`管理员: ${JSON.stringify(params)}`);

      this.$axios.post('/auth/manager/register', params).then(res => {
        this.$message.info('添加管理人员成功');
        this.formVisible = false;
        this.resetform();
      }).catch(res => {
        this.logining = false;
      })
    },

    query: function (offset) {
      let params = {
        userId: this.formQuery.userId,
        role: this.formQuery.role,
        qiyeId: this.formQuery.qiyeId,
        limit: this.pageSize,
        offset
      }
      this.$axios.post('/auth/user/list', params).then(res => {
        this.$message.info('查询管理员（后台管理员/企业管理员）成功');
        this.List = res.userList;
        console.log(`handleEditVisble: ${JSON.stringify(this.List)}`);
        this.totalSize = res.count;

      }).catch(res => {
        this.logining = false;
      })
    },

    handleCurrentChange: function (val) {
      this.query((val - 1) * this.pageSize);
    },

    handleQuery: function (row, val) {
      this.query(0);
      this.currentPage = 1;
    },

    handleRemove(_, fileList) {
      fileList.forEach((file) => {
        this.form.pic.push({
          name: file.name,
          url: file.url.split('blob:')[1]
        })
      })
    },
    beforeUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!');
      }
      return isLt2M;
    },
    handleSuccess(res, file) {
      this.form.pic.push({
        name: file.name,
        url: file.url.split('blob:')[1]
      });
    },

    handleCancel: function () {
      this.formVisible = false;
      this.resetform();
    },

    resetform: function () {
      this.form = {
        _id: "",
        name: "",
        info: "",
        pic: [],
        phone: "",
        email: "",
        role: 0,
        //企业
        qiyeId: "",
        qiyeName: "",
        extra : {}
      }
    }
  },
};

</script>

<style>
.user-table-expand {
  font-size: 0;
}

.user-table-expand label {
  width: 90px;
  color: #99a9bf;
}

.user-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 50%;
}

.hide-expand .el-table__expand-column .el-icon {
  visibility: hidden;
}
</style>
